/**
 * Created by Kieran on 09/10/2017.
 */

import axios from 'axios'
import config from '../../../config'


let MoodApi = {
  deleteMoodTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/moods/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  getMoodTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/moods/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getMoodsTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/moods/card/?requestFrom=web')
  },
  postMoodsTracking(model) {
    return axios.post(config.apiUrl + 'tracking/moods/', model)
  }
};

export default  MoodApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/Mood/index.js